module.exports = new Promise((resolve,reject) => {
                              const remoteUrl = window.__CONFIG__.REACT_APP_REVIEW_REMOTE_URL;
                              const script = document.createElement('script');
                              script.src = remoteUrl;
                              script.onload = () => {
                              const proxy = {
                                  get: (request) => window.reviewinformation.get(request),
                                  init: (arg) => {
                                  try {
                                    return window.reviewinformation.init(arg);
                                  } catch (e) {
                                    console.warn('reviewinformation remote already initialized');
                                  }
                                }
                              };
                              resolve(proxy);
                            };
                            script.onerror = (err) =>{
                              console.log('Failed to load remote script',err);
                              reject(new Error('Unable to load RemoteEntry file for docgen MFE'));
                            }
                            document.head.appendChild(script);
                      });